import PropTypes from "prop-types";

const LimitDisplay = (props) => {
    return <div className={`float-${props.float}`} style={{fontSize: '13px'}}> Pozostało
        znaków: {props.limit - (props.value?.length || 0)}</div>;
};

LimitDisplay.propTypes = {
    limit: PropTypes.number,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    float: PropTypes.oneOf(['end', 'start']),
};

export default LimitDisplay;
